import { requestData } from '@/api/request'
import { EHarvestSaleLotsApiUrl } from '@/api/urls'
import type { IHistoryItem } from '@/types/History'
import { createRouterLink } from '@/utils/url'

/** Сервис работы с историей заявки на продажу зерна outputs */
export default class SaleRequestHistoryService {
  /**
   * Получение истории заявки
   * @param {number} id - идентификатор заявки
   */
  getHistory = (id: number) =>
    requestData<IHistoryItem[]>({
      url: createRouterLink(EHarvestSaleLotsApiUrl.saleRequestHistory, { requestId: id }),
      method: 'GET',
    })
}
